<template>
  <div class="col-md-3 col-sm-12 col-xs-12">
    <q-select
      dense
      outlined
      v-model="responsavel"
      use-input
      hide-selected
      fill-input
      input-debounce="300"
      hint="Digite 3 caracteres para filtrar"
      :options="listaResponsaveis"
      @filter="filterFn"
      :option-label="
        (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
      "
    >
    </q-select>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { usuarioTemPermissao } from "../../../helpers/permissaoHelper";

export default {
  name: "SelectComponentResponsaveis",
  emits: ["emitirFuncionario"],
  props: ["resetar", "model", "vendorId"],

  setup(props, { emit }) {
    const responsavel = ref(props.model);
    const time = ref();
    const store = useStore();
    const listaResponsaveis = ref([]);
    const paginacao = ref({
      page: 1,
      rowsPerPage: 10,
    });

    // se tiver permissao de ver todos usuarios, não filtra por vendor_id
    const temPermissaoTodosUsuarios = computed(() =>
      usuarioTemPermissao(store, "visualizar_todos_usuários")
    );

    let listarFuncionarios = async (search) => {
      if (search === "") {
        listaResponsaveis.value = [];
        responsavel.value = "";
        return;
      }
      try {
        const vendorId = temPermissaoTodosUsuarios.value
          ? undefined
          : props.vendorId || store.state.org.unidadeData?.id || undefined;

        let resposta = await store.dispatch("fer/listarFuncionarios", {
          unidadeId: vendorId,
          paginacao: paginacao.value,
          search: search,
        });

        listaResponsaveis.value = resposta.listaFuncionarios;
        responsavel.value = resposta.listaFuncionarios[0];
      } catch (error) {
        console.error(error);
      }
    };

    watch(
      () => responsavel.value,
      () => {
        if (
          responsavel.value == "" &&
          responsavel.value == undefined &&
          responsavel.value == null
        ) {
          return;
        }
        emitirFuncionario(responsavel.value);
      }
    );

    watch(
      () => props.resetar,
      () => {
        responsavel.value = "";
      }
    );

    watch(
      () => props.model,
      () => {
        responsavel.value = props.model;
      }
    );

    let emitirFuncionario = async (emitirFuncionario, unidade) => {
      emit("emitirFuncionario", emitirFuncionario, unidade);
    };

    return {
      listaResponsaveis,
      listarFuncionarios,
      responsavel,
      emitirFuncionario,
      paginacao,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarFuncionarios(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
    };
  },
};
</script>
